import React from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const FaqInformationBox = (informationValue: any) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // 入力がNULLの場合、何も表示しない
  if (informationValue.value === null) {
    return <></>;
  }

  // よくある質問のデータ
  const faqData = [
    { question: "イベントの参加方法は？", answer: "イベント詳細を確認し、予約フォームに必要情報を入力してください。" },
    { question: "支払い方法は？", answer: "PayPayID「suzukikzy714」宛に参加費を送金してください。" },
    { question: "キャンセルは可能ですか？", answer: "キャンセルはイベント開催日の前日まで可能です。" },
    { question: "イベントの場所はどこですか？", answer: "イベント詳細に記載された場所にて開催されます。" }
  ];

  // レスポンシブ対応用のスタイル
  const iconSize = isMobile ? 24 : 32;
  const titleVariant = isMobile ? "h6" : "h5";
  const accordionPadding = isMobile ? "8px 16px" : "10px 20px";
  const questionFontSize = isMobile ? '14px' : '16px';
  const answerFontSize = isMobile ? '12px' : '14px';

  return (
    <Paper 
      elevation={3} 
      sx={{
        backgroundColor: '#e3f2fd', // 青系の背景色
        padding: 2,
        borderRadius: 2,
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        width: '80%',
        margin: '0 auto',
        marginBottom: '30px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
        <InfoIcon sx={{ color: '#2196f3', fontSize: iconSize, marginRight: 2 }} /> {/* アイコンのサイズ調整 */}
        <Typography variant={titleVariant} sx={{ fontWeight: 'bold', color: '#2196f3' }}>
          よくある質問
        </Typography>
      </Box>

      {faqData.map((item, index) => (
        <Accordion key={index} sx={{ marginBottom: 1, backgroundColor: '#e3f2fd' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}-content`}
            id={`panel${index}-header`}
            sx={{
              backgroundColor: '#2196f3', // 青色の背景
              color: '#ffffff',
              borderRadius: 2,
              padding: accordionPadding, // モバイル向けにパディング調整
            }}
          >
            <Typography sx={{ fontWeight: 'bold', fontSize: questionFontSize }}>
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: '#bbdefb' }}>
            <Typography sx={{ fontSize: answerFontSize }}>
              {item.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Paper>
  );
};
